import api from '@/api';

import { API_BASE_URL } from '.';
import {
  CreatePurchaseItemRequest,
  GenerateInvoiceReturnResponse,
  ItemsPurchaseReturnAll,
  PurchaseItem,
  PurchaseItemSellPriceUpdateRequest,
  PurchaseItemTagsData,
  PurchaseRemoveRequest,
  ReturnItemGenerateInvoiceRequest,
  ReturnItemQuery,
  UpdatePurchaseItemRequest,
} from './PurchaseItem.types';
import { PageRequest } from '@/core/request/PageRequest';
import { PageResult } from '@/core/request/PageResult';

const CONTROLLER_URL = `${API_BASE_URL}/purchases`;

export async function purchasesItemsList(params?: PageRequest) {
  const result = (await api.get(`${CONTROLLER_URL}/itens`, params)) as unknown;

  return result as PageResult<PurchaseItem>;
}

export async function purchaseItemCreate(
  obj: CreatePurchaseItemRequest,
): Promise<PurchaseItem> {
  const result = (await api.post(
    `${CONTROLLER_URL}/itens`,
    obj,
    null,
  )) as unknown;

  return result as PurchaseItem;
}

export async function purchaseItemListCreate(
  obj: CreatePurchaseItemRequest[],
): Promise<PurchaseItem[]> {
  const result = (await api.post(
    `${CONTROLLER_URL}/itens/list`,
    obj,
    null,
  )) as unknown;

  return result as PurchaseItem[];
}

export async function purchaseItemUpdate(
  obj: UpdatePurchaseItemRequest,
): Promise<PurchaseItem> {
  const result = (await api.put(
    `${CONTROLLER_URL}/itens`,
    obj,
    null,
  )) as unknown;

  return result as PurchaseItem;
}

export async function getPurchaseItem(id: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/itens/${id}`,
    {},
  )) as unknown;

  return result as PurchaseItem;
}

export async function itemPurchaseRemove(obj: PurchaseRemoveRequest) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/itens/${obj.id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function calculateTaxesItemPurchase(
  obj: UpdatePurchaseItemRequest,
) {
  const result = (await api.put(
    `${CONTROLLER_URL}/itens/calc-taxes`,
    obj,
    null,
  )) as unknown;

  return result as PurchaseItem;
}

export async function listItemPurchasesReturn(
  params: ReturnItemQuery,
): Promise<PageResult<PurchaseItem>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/itens/return`,
    params,
  )) as unknown;
  return result as PageResult<PurchaseItem>;
}

export async function itemPurchaseReturnGenerateInvoice(
  obj: ReturnItemGenerateInvoiceRequest,
) {
  const result = (await api.post(
    `${CONTROLLER_URL}/itens/return`,
    obj,
    null,
  )) as unknown;

  return result as GenerateInvoiceReturnResponse;
}

export async function purchasesReturnAllItemsList(params?: PageRequest) {
  const result = (await api.get(
    `${CONTROLLER_URL}/itens/return/all`,
    params,
  )) as unknown;

  return result as PageResult<ItemsPurchaseReturnAll>;
}

export async function getPurchaseItemsTags(purchaseId: number) {
  const result = (await api.get(`${CONTROLLER_URL}/itens/tags`, {
    purchaseId,
  })) as unknown;

  return result as PurchaseItemTagsData;
}

export async function purchaseItemsSellPriceUpdate(
  data: PurchaseItemSellPriceUpdateRequest[],
) {
  const result = (await api.patch(
    `${CONTROLLER_URL}/itens/update-sell-price`,
    data,
    null,
  )) as unknown;

  return result as void;
}
